import { Tabs } from "shared/components/Tabs";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useAuthContext } from "providers/Auth";
import { FEATURES } from "types/landlord/partner";

const SCREENING_TABS_CONFIG = {
  tabs: ["screening-templates", "discounts", "landlord-surveys"],
  displayMap: {
    "screening-templates": "Screening templates",
    discounts: "Discount codes",
    "landlord-surveys": "Landlord surveys"
  },
  routes: {
    "screening-templates": "/verification-templates",
    discounts: "/discounts",
    "landlord-surveys": "/landlord-surveys"
  }
};

export const ScreeningTabs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { permissions, partner } = useAuthContext();

  const handleTabChange = (tab: string) => {
    const route = SCREENING_TABS_CONFIG.routes[tab];
    if (route) navigate(route);
  };

  const isDiscounts = pathname.includes("/discounts");
  const isScreeningTemplates = pathname.includes("/verification-templates");
  const isLandlordSurveys = pathname.includes("/landlord-surveys");

  // Filter tabs based on permissions
  const availableTabs = useMemo(() => {
    const tabPermissions = {
      "screening-templates": permissions.canAccessScreeningTemplates !== false,
      discounts: permissions.canManageDiscounts !== false,
      "landlord-surveys":
        partner?.features.includes(
          FEATURES.WIP_FEAT_PREMIUM_RENTAL_VERIFICATION
        ) ?? false
    };

    return SCREENING_TABS_CONFIG.tabs.filter(
      (tab) => tabPermissions[tab] ?? true
    );
  }, [
    permissions.canAccessScreeningTemplates,
    permissions.canManageDiscounts,
    partner?.features
  ]);

  const selected = useMemo(() => {
    if (isDiscounts) return "discounts";
    if (isLandlordSurveys) return "landlord-surveys";
    return "screening-templates";
  }, [isLandlordSurveys, isDiscounts, isScreeningTemplates]);

  return (
    <Tabs
      tabs={availableTabs}
      selected={selected}
      setActiveTab={handleTabChange}
      displayMap={SCREENING_TABS_CONFIG.displayMap}
      variant="underline"
    />
  );
};
